import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const ONBOARDING_STEPS = [
  { step: 1, label: 'Create or join organization' },
  { step: 2, label: 'Tell us about yourself' },
  { step: 3, label: 'Clinic location' },
  { step: 4, label: 'Professional verification' },
  { step: 5, label: 'Public profile' },
  { step: 6, label: 'Client-facing features' },
  { step: 7, label: 'Plan overview' },
];

const TEAL = '#29C0BB';

const StepCircle = ({ state, number }) => (
  <Box
    sx={{
      width: 36,
      height: 36,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      backgroundColor: state === 'upcoming' ? '#fff' : TEAL,
      border: state === 'upcoming' ? '1.5px solid #d7dde3' : `1.5px solid ${TEAL}`,
      color: state === 'upcoming' ? '#8a94a0' : '#fff',
      fontWeight: 600,
      fontSize: 15,
      transition: 'all 0.2s',
    }}
  >
    {state === 'done' ? <CheckIcon sx={{ fontSize: 20 }} /> : number}
  </Box>
);

const OnboardingStepper = ({ currentStep, onStepClick }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', px: 2 }}>
    {ONBOARDING_STEPS.map(({ step, label }, i) => {
      const state = step < currentStep ? 'done' : step === currentStep ? 'active' : 'upcoming';
      const clickable = state === 'done' && !!onStepClick;
      return (
        <React.Fragment key={step}>
          {i > 0 && (
            <Box
              sx={{
                flex: 1,
                maxWidth: 90,
                height: '1.5px',
                mt: '18px',
                backgroundColor: step <= currentStep ? TEAL : '#d7dde3',
              }}
            />
          )}
          <Box
            onClick={clickable ? () => onStepClick(step) : undefined}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: 110,
              cursor: clickable ? 'pointer' : 'default',
              '&:hover .MuiTypography-root': clickable ? { textDecoration: 'underline' } : undefined,
            }}
          >
            <StepCircle state={state} number={step} />
            <Typography
              variant="caption"
              sx={{
                mt: 1,
                textAlign: 'center',
                lineHeight: 1.3,
                color: state === 'upcoming' ? '#8a94a0' : '#2C3E50',
                fontWeight: state === 'active' ? 700 : 400,
                display: { xs: 'none', md: 'block' },
              }}
            >
              {label}
            </Typography>
          </Box>
        </React.Fragment>
      );
    })}
  </Box>
);

export default OnboardingStepper;
